import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Button } from './Button';
import './Header.css';

function Header() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const [logo, setLogo] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const handleResize = () => {
        if (window.innerWidth <= 1000) {
            setButton(false);
            setLogo(false);
        } else {
            setButton(true);
            setLogo(true)
        }
    }

    useEffect(() => {
        handleResize();
    }, []);

    window.addEventListener('resize', handleResize);

    return (
        <>
            <IconContext.Provider value={{ color: '#fff' }}>
                <nav className='header'>
                    <div className='header-container'>
                        <Link to='/' className='header-logo' onClick={closeMobileMenu}>
                            {logo ? (
                                <img src='/images/banner.png' alt='Home Banner' />
                            ) : (
                                <img src='/images/logo.png' alt='Header Logo' />
                            )}
                        </Link>
                        <div className='menu-icon' onClick={handleClick}>
                            {click ? <FaTimes /> : <FaBars />}
                        </div>
                        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                            <li className='nav-item'>
                                <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                                    Home
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link to='/resume/' className='nav-links' onClick={closeMobileMenu}>
                                    Resume
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link to='/recipes/' className='nav-links' onClick={closeMobileMenu}>
                                    Recipes
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link to='/blog/' className='nav-links' onClick={closeMobileMenu}>
                                    Blog
                                </Link>
                            </li>
                            <li className='nav-btn'>
                                {button ? (
                                    <Link to='/contact/' className='btn-link'>
                                        <Button buttonStyle='btn--outline'>CONTACT</Button>
                                    </Link>
                                ) : (
                                    <Link to='/contact/' className='btn-link'>
                                        <Button buttonStyle='btn--outline' buttonSize='btn--mobile' onClick={closeMobileMenu}>
                                            CONTACT
                                        </Button>
                                    </Link>
                                )}
                            </li>
                        </ul>
                    </div>
                </nav>
            </IconContext.Provider>
        </>
    );
}

export default Header
